<div [formGroup]="form">
    <mat-form-field *ngIf="clients && clients.length > 1" class="nav-client-picker-ctr app-client-picker-form-field">
        <mat-icon matIconPrefix fontSet="fas" fontIcon="fa-search" class="nav-client-picker-icon"></mat-icon>
        <mat-select placeholder="Select Client" formControlName="clientName">
            <mat-option *ngIf="clients && clients.length > 1">NONE</mat-option>
            <mat-option *ngFor="let client of clients" [value]="client.clientCode">
                {{ client.clientName }}
            </mat-option>
        </mat-select>
    </mat-form-field>
    <div class="nav-client-single" *ngIf="clients && clients.length == 1">
        {{clients[0].clientName}}
    </div>
</div>